import SuperAuth0Guard from "./SuperAuth0Guard";

export default SuperAuth0Guard;
